import styled from 'styled-components';

import BackgroundBox from 'shared/components/BackgroundBox';
import { device } from 'shared/defaultTheme';

export const DocumentationBackground = styled(BackgroundBox)`
  @media ${device.sm} {
    width: 97%;
    margin-left: 6px;
    .row {
      display: block;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;
    }
  }
  @media ${device.md} {
    width: 97%;
    margin-left: 10px;
    .row {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;
    }
  }
  @media ${device.lg} {
    width: 97%;
    margin-left: 14px;
    .row {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;
    }
  }
  @media ${device.xl} {
    width: 90%;
    margin-left: 0;
    .row {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;
    }
  }
`;
